import {apiGetUserLogs} from "api/reportApi";

const userLogColumns = [
    {
        name: "تاریخ",
        key: "date",
        searchType: "date",
        disableSearch: true
    },
    {
        name: "ساعت",
        key: "time",
        disableSearch: true
    },
    {
        name: "کاربر",
        key: "User",
        disableSearch: true
    },
    {
        name: "عملیات",
        key: "action",
        disableSearch: true
    },
    {
        name: "عنوان",
        key: "title",
        disableSearch: true
    },
    {
        name: "شرح",
        key: "description",
        disableSearch: true
    },
];

export const userLogIndexData = [
    {
        key: "users-log",
        label: "لاگ کاربران",
        pluralLabel: "لاگ کاربران",
        title: "لاگ کاربران",
        pageTitle: "لاگ کاربران",
        // pageDescription: "نمایش کالا و خدمات کسب و کار",
        tableColumns: userLogColumns,
        disableSearch: true,
        actions: {
            back: {},
            fetch: apiGetUserLogs,
            // excel: {},
        },
    },
];
